import { render, staticRenderFns } from "./AppUnauthorized.vue?vue&type=template&id=0fd5ad17&lang=pug"
import script from "./AppUnauthorized.vue?vue&type=script&lang=ts"
export * from "./AppUnauthorized.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports